import styles from "./Details.module.css";
import { Input } from "../../../common/Input";
import { Button } from "../../../common/Button";
import { useContext, useState } from "react";
import { KlashaSelect } from "../../../common/KlashaSelect";
import { ButtonFooter } from "../../../common/ButtonFooter";
import { StatusContext } from "../../../../context/Status";

type BankOption = {
  value: string;
  label: string;
};

interface DetailsProps {
  bankList: BankOption[];
  onChange: (bankOption: any) => void;
  bankCode: any;
  hasBankCode: boolean;
  isLoading?: boolean;
}

export const Details = ({
  bankList,
  onChange,
  bankCode,
  hasBankCode,
  isLoading,
}: DetailsProps) => {
  const [isCopied, setIsCopied] = useState(false);
  const { setPageTransactionStatus } = useContext(StatusContext);
  const [btnLoading, setBtnLoading] = useState(isLoading);

  const onPaid = () => {
    setPageTransactionStatus("processing");
    setBtnLoading(true);
  };

  async function copyTextToClipboard(text: string) {
    if ("clipboard" in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand("copy", true, text);
    }
  }

  const onCopy = () => {
    copyTextToClipboard(bankCode)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className={styles.container}>
      <form>
        <div className={styles.form}>
          <KlashaSelect
            label="Bank name"
            onChange={onChange}
            options={bankList}
          />
          {/*<Input type="text" label="Bank name" required/>*/}
          <div className={styles.copyUssd}>
            <div className={styles.code}>
              <Input
                value={bankCode}
                inputId="ussdCode"
                readOnly
                type="text"
                label="USSD code"
                required
              />
              <p className={styles.inputNote}>
                <span>*</span> Enter the code on the phone number linked to your
                bank account
              </p>
            </div>
            <button
              className={styles.ussdCopyBtn}
              onClick={onCopy}
              type="button"
              disabled={!hasBankCode}
            >
              {isCopied ? "Copied" : "Copy"}
            </button>
          </div>
        </div>
        <ButtonFooter showNote>
          <Button
            type="button"
            text="I have paid"
            buttonStyle="primary"
            onClick={onPaid}
            disabled={!hasBankCode}
            isButtonLoading={btnLoading}
          />
        </ButtonFooter>
      </form>
    </div>
  );
};
